import { useState, useEffect, useContext, useRef } from "react"
import { currentSearch } from "../contexts/Search";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Forum from "../components/Forum";
import Loading from "../components/Loading";
import Filter from "../components/Filter";
import Unauth from '../components/Unauth';
import { CurrentUser } from '../contexts/CurrentUser';

import { renderPagination } from "../components/Pagination";

function Forums() {
    const scrollPanel = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const { query, setQuery, results: { meta, rows = [] }, isLoading } = useContext(currentSearch);
    const { pages = 0 } = meta;

    useEffect(() => {
        const { current } = scrollPanel || {};
        if (current) {
            current.scrollTop = 0;
        }

    }, [rows, scrollPanel]);


    useEffect(() => {
        const fetchData = async () => {
            setQuery({ ...query, term: searchTerm, mode: 'forums', slug: '', page: 1 })
        }
        fetchData()
    }, [searchTerm])

    function setFilter(newTerm) {
        setSearchTerm(newTerm);
    }

    const { isLoggedIn } = useContext(CurrentUser);
    if (!isLoggedIn) {
        return <Unauth/>
    }

    return (
        <Container className="forums-page">
            <Row className="topic-header-area">
                <Col className='topic-header'>
                    <h3 className='topic-header-text'>Forums</h3>
                    <Filter 
                        placeholder="Filter by forum name"
                        setFilter={setFilter} 
                        isLoading={isLoading} 
                        historyKey='forum-filter' />
                </Col>
            </Row>
            <Row className={pages <= 1 ? 'scroll-container' : 'scroll-container-search'} ref={scrollPanel}>
                <Col className="scrolled-contents">
                    {
                        isLoading ?
                            <Loading />
                            :
                            rows.map((forum, index) => {
                                return <Forum key={`${forum.id}${index}`} forum={forum} />
                            })
                    }
                </Col>
            </Row>
            {renderPagination(meta)}
        </Container>
    );
}

export default Forums;